import React from 'react';
import { VaBreadcrumbs } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { claimantOverviewBC } from '../utilities/poaRequests';

const ClaimantNotFound = () => {
  document.title =
    'Claimant not found | Accredited Representative Portal | Veterans Affairs';
  return (
    <section className="vads-u-width--full claimant-overview">
      <div className="claimant-overview__breadcrumbs">
        <VaBreadcrumbs
          breadcrumbList={claimantOverviewBC}
          homeVeteransAffairs={false}
          wrapping
        />
      </div>

      <h1 className="vads-u-margin-top--0 vads-u-margin-bottom--2">
        Claimant not found
      </h1>

      <div className="vads-l-grid-row">
        <div className="vads-l-col--12 medium-screen:vads-l-col--8">
          <div className="vads-u-margin-y--2">
            <va-alert status="info">
              <h2 slot="headline">You don’t represent this claimant</h2>
              <p>
                This claimant may be in our system, but you can’t access their
                information or act on their behalf until you establish
                representation.
              </p>
              <a href="/representative/help#establishing-representation">
                Learn about establishing representation
              </a>
            </va-alert>
          </div>
        </div>
      </div>

      <a
        className="vads-c-action-link--green vads-u-margin-top--2"
        href="/representative/find-claimant"
      >
        Find another claimant
      </a>
    </section>
  );
};

export default ClaimantNotFound;
